/// <reference types="@types/segment-analytics" />

declare global {
  interface Window {
    analytics?: SegmentAnalytics.AnalyticsJS;
  }
}

class DummyAnalyticsJS implements SegmentAnalytics.AnalyticsJS {
  use(plugin: (analytics: SegmentAnalytics.AnalyticsJS) => void): this {
    console.warn("analytics not loaded");
    return this;
  }
  init(
    settings?: SegmentAnalytics.IntegrationsSettings | undefined,
    options?: SegmentAnalytics.InitOptions | undefined
  ): this {
    console.warn("analytics not loaded");
    return this;
  }
  addIntegration(integration: (options: any) => void): this {
    console.warn("analytics not loaded");
    return this;
  }
  setAnonymousId(id: string): this {
    console.warn("analytics not loaded");
    return this;
  }
  load(writeKey: string): void;
  load(writeKey: string, options?: SegmentAnalytics.SegmentOpts | undefined): void;
  load(writeKey: any, options?: any) {
    console.warn("analytics not loaded");
  }
  identify(
    userId: string,
    traits?: Object | undefined,
    options?: SegmentAnalytics.SegmentOpts | undefined,
    callback?: (() => void) | undefined
  ): void;
  identify(userId: string, traits: Object, callback?: (() => void) | undefined): void;
  identify(userId: string, callback?: (() => void) | undefined): void;
  identify(
    traits?: Object | undefined,
    options?: SegmentAnalytics.SegmentOpts | undefined,
    callback?: (() => void) | undefined
  ): void;
  identify(traits?: Object | undefined, callback?: (() => void) | undefined): void;
  identify(callback: () => void): void;
  identify(userId?: any, traits?: any, options?: any, callback?: any) {
    console.warn("analytics not loaded");
  }
  track(
    event: string,
    properties?: Object | undefined,
    options?: SegmentAnalytics.SegmentOpts | undefined,
    callback?: (() => void) | undefined
  ): void;
  track(event: string, properties?: Object | undefined, callback?: (() => void) | undefined): void;
  track(event: string, callback?: (() => void) | undefined): void;
  track(event: any, properties?: any, options?: any, callback?: any) {
    console.warn("analytics not loaded");
  }
  page(
    category?: string | undefined,
    name?: string | undefined,
    properties?: Object | undefined,
    options?: SegmentAnalytics.SegmentOpts | undefined,
    callback?: (() => void) | undefined
  ): void;
  page(
    name?: string | undefined,
    properties?: Object | undefined,
    options?: SegmentAnalytics.SegmentOpts | undefined,
    callback?: (() => void) | undefined
  ): void;
  page(name?: string | undefined, properties?: Object | undefined, callback?: (() => void) | undefined): void;
  page(name?: string | undefined, callback?: (() => void) | undefined): void;
  page(
    properties?: Object | undefined,
    options?: SegmentAnalytics.SegmentOpts | undefined,
    callback?: (() => void) | undefined
  ): void;
  page(callback?: (() => void) | undefined): void;
  page(category?: any, name?: any, properties?: any, options?: any, callback?: any) {
    console.warn("analytics not loaded");
  }
  group(
    groupId: string,
    traits?: Object | undefined,
    options?: SegmentAnalytics.SegmentOpts | undefined,
    callback?: (() => void) | undefined
  ): void;
  group(groupId: string, traits?: Object | undefined, callback?: (() => void) | undefined): void;
  group(groupId: string, callback?: (() => void) | undefined): void;
  group(): { id(): string; traits(newTraits?: Object | undefined): void };
  group(groupId?: any, traits?: any, options?: any, callback?: any) {
    console.warn("analytics not loaded");
    return this.group();
  }
  alias(
    userId: string,
    previousId?: string | undefined,
    options?: SegmentAnalytics.SegmentOpts | undefined,
    callback?: (() => void) | undefined
  ): void;
  alias(userId: string, previousId?: string | undefined, callback?: (() => void) | undefined): void;
  alias(userId: string, callback?: (() => void) | undefined): void;
  alias(userId: string, options?: SegmentAnalytics.SegmentOpts | undefined, callback?: (() => void) | undefined): void;
  alias(userId: any, previousId?: any, options?: any, callback?: any) {
    console.warn("analytics not loaded");
  }
  trackLink(
    elements: JQuery | Element | Element[],
    event: string | ((elm: Element) => string),
    properties?: Object | ((elm: Element) => Object) | undefined
  ): void {
    console.warn("analytics not loaded");
  }
  trackForm(
    elements: JQuery | Element | Element[],
    event: string | ((elm: Element) => string),
    properties?: Object | ((elm: Element) => Object) | undefined
  ): void {
    console.warn("analytics not loaded");
  }
  ready(callback: () => void): void {
    console.warn("analytics not loaded");
  }
  reset(): void {
    console.warn("analytics not loaded");
  }
  user(): {
    id(): string;
    logout(): void;
    reset(): void;
    anonymousId(newId?: string | undefined): string;
    traits(newTraits?: Object | undefined): void;
  } {
    console.warn("analytics not loaded");
    return this.user();
  }
  debug(state?: boolean | undefined): void {
    console.warn("analytics not loaded");
  }
  on(
    event: string,
    callback: (event: string, properties: Object, options: SegmentAnalytics.SegmentOpts) => void
  ): void {
    console.warn("analytics not loaded");
  }
  timeout(milliseconds: number): void {
    console.warn("analytics not loaded");
  }
}
// @ts-ignore
if (typeof window === "undefined") global.window = {};
if (!window.analytics) window.analytics = new DummyAnalyticsJS();

export default window.analytics;
